<template>
  <div>
    <popup
      v-model="isShow"
      position="bottom"
      v-if="type === 'provinces'"
    >
      <div class="keyboard-content">
        <ul
          class="keyboard-list"
          v-for="(i, index) in provincesData"
          :key="index">
          <li
            v-for="(item, itemIndex) in i"
            :key="itemIndex"
            @click="clickKey(item.value, 'provinces')"
            @touchstart="handleTouchStart(item.value)"
            @touchend="handleTouchEnd(item.value)"
            v-bind:class="{'touch-start': currentTouchStart === item.value}"
          >
            {{ item.value}}
          </li>
        </ul>
      </div>
    </popup>
    <popup
      v-model="isShow"
      position="bottom"
      v-if="type === 'alphanumeric'"
    >
      <div class="keyboard-content">
        <ul
          class="keyboard-list"
          v-for="(i, index) in alphanumeric"
          :key="index">
          <li
            v-for="(item, itemIndex) in i"
            :key="itemIndex"
            @click="clickKey(item, 'alphanumeric')"
            v-bind:class="{
              'delete': item === 'delete' ,
              'touch-start': currentTouchStart === item,
              'end': item === 'end'}"
            @touchstart="handleTouchStart(item)"
            @touchend="handleTouchEnd(item)"
          >
            {{ showItem(item) }}
            <img
              class="delete-icon"
              src="../../assets/key_delete_icon.png"
              v-if="item === 'delete'">
          </li>
        </ul>
      </div>
    </popup>
    <div ref="reference">
      <slot name="reference"></slot>
    </div>
  </div>
</template>
<script>
  import popup from '../popup'
  import provinces from './provinces_abbreviation'
  import alphanumeric from './alphanumeric'
  import { on, off } from '../../utils/dom'
  export default {
    components: {
      popup
    },
    methods: {
      clickKey(value, type) {
        if (type === 'provinces') {
          this.isShow = false
        }
        if (value === 'delete') {
          this.$emit('handle-delete', value)
        } else if (value === 'end') {
          this.isShow = false
        } else {
          this.$nextTick(() => {
            this.$emit('handle-value', value)
          })
        }
      },
      handleTouchStart(value) {
        this.currentTouchStart = value
      },
      handleTouchEnd(value) {
        this.currentTouchStart = ''
      },
      handleProvincesData() {
        let provincesArr = []
        provincesArr.push(provinces.slice(0, 10))
        provincesArr.push(provinces.slice(10, 19))
        provincesArr.push(provinces.slice(19, 26))
        provincesArr.push(provinces.slice(26))
        return provincesArr
      },
      handleAlphanumericData() {
        let alphanumericArr = []
        alphanumericArr.push(alphanumeric.slice(0, 10))
        alphanumericArr.push(alphanumeric.slice(10, 20))
        alphanumericArr.push(alphanumeric.slice(20, 30))
        alphanumericArr.push(alphanumeric.slice(30))
        return alphanumericArr
      },
      showItem(value) {
        if (value === 'delete') {
          return ''
        } else if (value === 'end') {
          return '完成'
        } else {
          return value
        }
      },
      doToggle() {
        this.isShow = !this.isShow
      },
      handleDocumentClick(e) {
        let reference = this.$refs.reference
        if (!this.$el ||
          !reference ||
          this.$el.contains(e.target) ||
          reference.contains(e.target)) return
        this.isShow = false
      }
    },
    created () {},
    mounted() {
      let reference = this.$refs.reference
      on(reference, 'click', this.doToggle)
      on(document, 'click', this.handleDocumentClick)
    },
    destroyed() {
      let reference = this.$refs.reference
      off(reference, 'click', this.doToggle)
      off(document, 'click', this.handleDocumentClick)
    },
    model: {
      prop: 'show',
      event: 'change'
    },
    props: {
      type: {
        type: String,
        default () {
          return 'provinces'
        }
      },
      show: {
        type: Boolean,
        default () {
          return false
        }
      }
    },
    data () {
      return {
        provincesData: this.handleProvincesData(), // 省份简称数据
        alphanumeric: this.handleAlphanumericData(), // 字母键盘数据
        isShow: this.show,
        currentTouchStart: '' // 当前按下元素
      }
    },
    watch: {
      show (newValue, oldValue) {
        this.isShow = newValue
      },
      isShow (newValue, oldValue) {
        if (newValue) {
          let mask = document.querySelector('.vux-popup-mask')
          mask.style.background = 'rgba(0,0,0,0)'
          mask.style.display = 'none'
          this.$emit('on-show')
        } else {
          let mask = document.querySelector('.vux-popup-mask')
          mask.style.background = 'rgba(0, 0, 0, 0.6)'
          mask.style.display = 'block'
          this.$emit('on-hide')
        }
        this.$emit('change', newValue)
      }
    }
  }
</script>
<style lang="less">
  @import '../../styles/cui/base/fn';
  .keyboard-content{
    padding: 20/@w2 10/@w2 25/@w2;
    background-color: #d1d6dc;
    .keyboard-list{
      display: flex;
      justify-content: center;
      &:not(:last-child){
        margin-bottom: 23/@w2;
      }
      li{
        width: 64/@w2;
        height: 90/@w2;
        background-color: #ffffff;
        box-shadow: 0px 2/@w2 8/@w2 0px
        rgba(101, 104, 107, 0.5),
        inset 0px -3/@w2 0px 0px
        rgba(209, 214, 220, 0.5);
        border-radius: 8/@w2;
        text-align: center;
        line-height: 90/@w2;
        list-style-type: none;
        font-size: 15px;
        &:not(:last-child){
          margin-right: 10/@w2;
        }
        &.end{
          width: 138/@w2;
          background-color: #5890ff;
          color: #ffffff;
        }
        &.delete{
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .delete-icon{
          display: block;
          width: 44/@w2;
          height: 40/@w2;
        }
        &.touch-start{
          background-color: #8f969e;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// keyboard.vue?695bdb2f